// extracted by mini-css-extract-plugin
export default {"wrapper":"PatientBaselinePage_wrapper__+SBdF"};